module.exports = __webpack_public_path__ + "img/step39_a_printer_power_open_main_door_remove_pins.04b244ed.png";